// removed by extract-text-webpack-plugin
module.exports = {"messages":"c-Messages__messages","message":"c-Messages__message","messagesList":"c-Messages__messagesList","title":"c-Messages__title","code":"c-Messages__code","name":"c-Messages__name","icon":"c-Messages__icon","buttonWrapper":"c-Messages__buttonWrapper","button":"c-Messages__button"};


//////////////////
// WEBPACK FOOTER
// ./src/components/presentational/Messages/Messages.scss
// module id = 837
// module chunks = 0